module.exports = __webpack_public_path__ + "static/media/Murmuratto_Template_Questions_Test.cc4e2183.csv";